import { render, staticRenderFns } from "./RiskData.vue?vue&type=template&id=8644be28&scoped=true&"
import script from "./RiskData.vue?vue&type=script&lang=js&"
export * from "./RiskData.vue?vue&type=script&lang=js&"
import style0 from "./RiskData.vue?vue&type=style&index=0&id=8644be28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8644be28",
  null
  
)

export default component.exports